import React from 'react'
import { connect } from 'react-redux'
import { addListItem, deleteListItem, nullDate, } from '../../public/utility'
import { doGetLeaveApply, doSaveLeaveApply, doDeleteLeaveApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue, } from '../../public/utility/formValues'
import { doLeaveApplyAction } from '../../business/LeaveApplyAction'
class LeaveCancelApply extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id || 0,
    }

    componentDidMount = () => {
        const { id } = this.state
        const { dispatch, checkRecordID, taskName } = this.props
        if(id == 0){
            Tyan.doPostEvent({
                event: 'GetLeaveApplyNumbers',
                data: { id },
                onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    this.setState({ initValues基本信息, optionsParas, id })
                }
            })
        }
        else{
            Tyan.doPostEvent({
                event: 'GetLeaveApply',
                data: { id: id || 0, checkRecordID, taskName,},
                onEnd: ({ errorMessage, initValues基本信息, initValues假期余额, initValues出差事由, optionsParas }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    this.setState({ id, initValues基本信息, initValues假期余额, initValues出差事由, changedValues出差事由: {}, changedValues基本信息: {}, optionsParas })
                }
            })
        }
        
    }

    componentWillUnmount = () => {
        this.unmount = true
    }

    handlerSave = () => {
        const { dispatch, checkRecordID } = this.props
        const { id, changedValues基本信息, initValues基本信息, changedValues出差事由 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        var newChangeValue = changedValues基本信息
        if (id == 0) {
            newChangeValue = {
                请假开始日期: values.请假开始日期,
                请假结束日期: values.请假结束日期,
                请假开始时段: values.请假开始时段,
                请假结束时段: values.请假结束时段,
                请假开始时间: values.请假开始时间,
                请假结束时间: values.请假结束时间,
                ...changedValues基本信息
            }
        }
        dispatch(doSaveLeaveApply({
            id,
            checkRecordID,
            changedValues基本信息: newChangeValue,
            changedValues出差事由,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetLeaveApply(id)
                }
            }
        }))
    }

    handlerDelete = () => {
        const { dispatch, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteLeaveApply({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        window.history.back()
                    }
                }
            })))
    }

    handelSubmit = (action, title) => {
        const { id, changedValues基本信息 } = this.state
        Tyan.pubForm.showConfirm('确定要提交？', () =>
            Tyan.doPostEvent({
                event: 'LeaveApplyFlow',
                data: { id, action, changedValues基本信息 },
                onRequest: () => {
                    this.setState({ loading: true })
                },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    this.setState({ loading: false })
                    window.history.back()
                }
            })
        )
    }

    handlerClose = () => {
        if (!this.bChanged()) {
            window.history.back()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    }

    handlerAddInfo = () => {
        addListItem(this, {}, '出差事由', '出差事由')
    }

    handlerDeleteInfo = (id) => {
        deleteListItem(this, '出差事由', '出差事由', id)
    }

    handleChange = (v) => {
        Tyan.doPostEvent({
            event: 'GetLeaveApplyByNumber',
            data: { number: v },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ loading: false, initValues基本信息, optionsParas, id })
            }
        })
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, optionsParas } = this.state
        const { 状态名称 } = initValues基本信息
        const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
        const 职务代理人 = getFormValue(this, '基本信息', '职务代理人')
        const 司机确认时间 = getFormValue(this, '基本信息', '司机确认时间')
        const 假期时段 = 假勤项目 && optionsParas['假期时段'][假勤项目] || ''
        return [
            { _select: '申请编号', editable: true, onChange: (v) => this.handleChange(v) },
            { _select: '职务代理人', disabled: true, },
            { _select: '假勤项目', disabled: true, },
            { _date: '请假开始日期', cdt: () => 假期时段 && 假期时段 == '每天一时段', disabled: true, },
            { _select: '请假开始时段', cdt: () => 假期时段 && 假期时段 == '每天一时段', disabled: true, },
            { _date: '请假结束日期', cdt: () => 假期时段 && 假期时段 == '每天一时段', disabled: true, },
            { _select: '请假结束时段', cdt: () => 假期时段 && 假期时段 == '每天一时段', disabled: true, },
            { _datetime: '请假开始时间', cdt: () => 假期时段 && 假期时段 == '连续时段', disabled: true, },
            { _datetime: '请假结束时间', cdt: () => 假期时段 && 假期时段 == '连续时段', disabled: true, },
            { _select: '服务单位', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差'), disabled: true, },
            { _radio: '是否产生误餐费', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差'), disabled: true, },
            { _select: '出差类别', cdt: () => 假勤项目 && 假勤项目 == '出差', disabled: true, },
            { _select: '出行方式', editable: true, forceSelection: false, cdt: () => 假勤项目 && 假勤项目 == '出差', disabled: true, },
            { _text: 假勤项目 && 假勤项目 == '出差' ? '出差原因' : '请假原因', name: '请假原因', maxRows: 3, cdt: () => 假勤项目 && 假勤项目 != '出差', disabled: true, },
            { _text: '任务交接说明', maxRows: 3, cdt: () => 职务代理人, disabled: true, },
            { _files: '出差报告', disabled: 状态名称 !== '报告中', cdt: () => 假勤项目 && 假勤项目 == '出差' && (状态名称 == '请假完成' || 状态名称 == '报告中'), disabled: true, },
            { _files: '请假附件', required: ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) > -1, disabled: true, },
            { _text: '请假备注', maxRows: 3, disabled: true, },

            { _text: '车牌号码', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },
            { _text: '驾驶员', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },

            { _text: '销假申请原因', maxRows: 3, },
            { _files: '附件', },
            { _text: '备注', maxRows: 3, },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, id } = this.state
        const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 状态名称 } = initValues基本信息
        return <Body data={this} /* maxWidth="1100" */
            controls={
                [
                    { _button: '提交', icon: '', handler: () => this.handelSubmit(状态名称=='请假完成'?`${状态名称}.销假申请`:`${状态名称}.提交`, '提交'),cdt: () => id > 0 && 假勤项目 !== '外训',  disabled: id == 0 },
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '销假申请', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '68%', },
                    { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(LeaveCancelApply)